/*global FakeCation, document, ga */
(function (FC) {
  "use strict";
  const stageId = 'UA-45874495-6';
  const prodId = 'UA-45874495-5';
  
  var pageId = stageId;
  
  if(location.hostname === 'selfiehop.euedge.com') {
    pageId = prodId;
  }

  /* eslint-disable */
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

  ga('create', pageId , 'auto');
  ga('send', 'pageview');  
  /* eslint-enable */

  FC.ga = function(param) {
    ga('set','page',param);
    ga('send','pageview');
  };
  
}(FakeCation));
